var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-data-table", {
    attrs: {
      headers: _vm.headers,
      items: _vm.changeLog,
      "items-per-page-text": _vm.rowsPerPageText,
      "items-per-page": _vm.paginationChangeLog.rowsPerPage,
      "items-per-page-items": _vm.rowsPerPageItems,
      "header-props": { sortIcon: _vm.sortIcon },
      "footer-props": {
        prevIcon: _vm.prevIcon,
        nextIcon: _vm.nextIcon,
        "items-per-page-options": _vm.rowsPerPageItems
      },
      loading: _vm.loading,
      "loading-text": ""
    },
    on: {
      "update:itemsPerPage": function($event) {
        return _vm.$set(_vm.paginationChangeLog, "rowsPerPage", $event)
      },
      "update:items-per-page": function($event) {
        return _vm.$set(_vm.paginationChangeLog, "rowsPerPage", $event)
      },
      pagination: function($event) {
        return _vm.setRowsOnLocalStorage(
          _vm.dataTableChangeLogId,
          _vm.paginationChangeLog.rowsPerPage
        )
      }
    },
    scopedSlots: _vm._u([
      {
        key: "item",
        fn: function(props) {
          return [
            _c("tr", [
              _c("td", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.getFormattedDate(props.item.updated_at)) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.getUserCauserName(props.item.causer_user)) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n        " + _vm._s(props.item.description) + "\n      "
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v("\n        " + _vm._s(props.item.attribute) + "\n      ")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n        " +
                    _vm._s(props.item.oldValue ? props.item.oldValue : "") +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v("\n        " + _vm._s(props.item.newValue) + "\n      ")
              ])
            ])
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46761392", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46761392","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/ChangeLogForm/ChangeLogDataTable.vue
// module id = null
// module chunks = 